/* eslint no-prototype-builtins: "off" */

'use strict';

const navigator = {};

navigator.getTransition = function() {
    let el = document.createElement('bootstrap');
    let name;
    let transEndEventNames = {
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'oTransitionEnd otransitionend',
            'transition': 'transitionend',
        };
    let transNames = {
            'WebkitTransition': '-webkit-transition',
            'MozTransition': '-moz-transition',
            'OTransition': '-o-transition',
            'transition': 'transition',
        };

    for (name in transEndEventNames) {
        if (transEndEventNames.hasOwnProperty(name) && el.style[name] !== undefined) {
            return {
                'end': transEndEventNames[name],
                'name': transNames[name],
            };
        }
    }

    return false; // explicit for ie8
};

navigator.getTransform = function() {
    let prefixes = ['transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'msTransform'];
    let i;
    let div = document.createElement('div');

    for (i = 0; i < prefixes.length; i = i + 1) {
        if (div && div.style[prefixes[i]] !== undefined) {
            return prefixes[i];
        }
    }

    return false;
};

module.exports = navigator;
